import { createStyles } from 'antd-style';

import { ThemeSpaces } from '../../theme';

export const useMonitorNoDataStyles = createStyles(() => ({
  monitorNoData: {
    margin: `${ThemeSpaces.SPACE_NORM_20}px auto 0 auto`,
    textAlign: 'center',
  },
}));
